export function canSwitchMode(mode) {
    return true;
}
//# sourceMappingURL=view-mode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/engine/view-mode.js
// module id = 528
// module chunks = 10